import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery, SubscriptionBasicInformationDto } from "../../interfaces";

export type StudentSubscriptionsPage = {
  data: SubscriptionBasicInformationDto[];
  meta: {
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    totalPages: number;
  };
};

export const studentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStudentsV2: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/user/student/v2`),
      }),
      providesTags: ["Paginated-Students"],
    }),
    getStudentSubscriptions: builder.query<
      StudentSubscriptionsPage,
      { studentId: string; page: number; limit: number }
    >({
      query: ({ studentId, page, limit }) => ({
        url: `/api/user/student/${studentId}/subscriptions?page=${page}&limit=${limit}`,
      }),
      providesTags: ["Subscription"],
    }),
    updateStudentUser: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/user/student/admin/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Students"],
    }),
  }),
});

export const {
  useGetStudentsV2Query,
  useGetStudentSubscriptionsQuery,
  useUpdateStudentUserMutation,
} = studentApi;
